import { api } from '../api/client';
import type { ApiResponse } from '../api/types';

export interface PaymentGatewayConnectRequest {
  payment_gateway_id: string;
}

export interface PaymentGatewayConnectResponse {
  success: boolean;
  message: string;
  redirect_url?: string;
}

export interface CashfreeSetupRequest {
  payment_gateway: string;
  payment_flow: number;
  config: {
    api_key: string;
    api_secret: string;
  };
}

export interface CashfreeSetupResponse {
  success: boolean;
  message: string;
}

export interface PaymentGatewaySetupRequest {
  payment_gateway: string;
  payment_flow: number;
  config: {
    api_key: string;
    api_secret: string;
  };
}

export interface PaymentGatewaySetupResponse {
  success: boolean;
  message: string;
}

export interface DeleteConnectionResponse {
  success: boolean;
  message: string;
}

export const connectionService = {
  connect: (paymentGatewayId: string): Promise<ApiResponse<PaymentGatewayConnectResponse>> =>
    api.post('merchant/v1/onboard-payment-gateway/', { payment_gateway: paymentGatewayId }),
  onboard: (paymentGatewayUuid: string): Promise<ApiResponse<PaymentGatewayConnectResponse>> =>
    api.post(`merchant/v1/onboard-payment-gateway/${paymentGatewayUuid}`, { payment_gateway: paymentGatewayUuid }),
  setupCashfree: (data: CashfreeSetupRequest): Promise<ApiResponse<CashfreeSetupResponse>> =>
    api.post('merchant/v1/onboard-payment-gateway/', data),    
  setupPaytm: (data: CashfreeSetupRequest): Promise<ApiResponse<CashfreeSetupResponse>> =>
    api.post('merchant/v1/onboard-payment-gateway/', data),
  setupEasebuzz: (data: PaymentGatewaySetupRequest): Promise<ApiResponse<PaymentGatewaySetupResponse>> =>
    api.post('merchant/v1/onboard-payment-gateway/', data),
  setupPayU: (data: PaymentGatewaySetupRequest): Promise<ApiResponse<PaymentGatewaySetupResponse>> =>
    api.post('merchant/v1/onboard-payment-gateway/', data),
  deleteConnection: (connectionId: string): Promise<ApiResponse<DeleteConnectionResponse>> =>
    api.delete(`merchant/v1/delete-payment-gateway/${connectionId}/`),
};